import React, { useEffect } from "react";

// https://fkhadra.github.io/react-contexify/
import { Menu, Item, Submenu, contextMenu } from "react-contexify";
import "react-contexify/ReactContexify.css";

import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";
import { EventKey } from "../../eventLogger/EventKeys";

const MENU_ID = "tree";

export default function ContextMenu() {
  useEffect(() => {
    (window as any).contextMenu = contextMenu;
  }, []);

  // Clamp open submenus so they never overflow the viewport.
  //
  // React-contexify v6 shows submenus via CSS :hover (not a class change), so
  // MutationObserver would not help here. Instead we use a capturing mouseenter
  // listener and run AFTER react-contexify's own onMouseEnter (setSubmenuPosition)
  // via setTimeout(0), which is when contexify_submenu-bottom has been applied.
  useEffect(() => {
    const handleMouseEnter = (e: Event) => {
      try {
        const item =
          (e.target as HTMLElement).closest &&
          (e.target as HTMLElement).closest<HTMLElement>(".contexify_item[aria-haspopup]");
        if (!item) return;
        setTimeout(() => {
          const submenu = item.querySelector<HTMLElement>(":scope > .contexify_submenu"); // no itx
          if (!submenu) return;

          // Reset previous inline constraints so measurement is accurate.
          submenu.style.removeProperty("max-height");
          submenu.style.removeProperty("overflow-y");

          const rect = submenu.getBoundingClientRect();
          if (rect.height === 0) return;

          const vh = window.innerHeight;
          if (rect.top < 0) {
            // Submenu opens upward and clips above viewport.
            const available = rect.bottom - 8;
            if (available > 0) {
              submenu.style.maxHeight = `${available}px`;
              submenu.style.overflowY = "auto";
            }
          } else if (rect.bottom > vh) {
            // Submenu opens downward and clips below viewport.
            const available = vh - rect.top - 8;
            if (available > 0) {
              submenu.style.maxHeight = `${available}px`;
              submenu.style.overflowY = "auto";
            }
          }
        }, 0);
      } catch (error) {
        console.error("Error in context menu mouseenter handler:", error);
      }
    };
    document.addEventListener("mouseenter", handleMouseEnter, true);
    return () => document.removeEventListener("mouseenter", handleMouseEnter, true);
  }, []);

  useOnChangeWatcher(state.contextMenuManager);

  const obj = state.contextMenuManager.currentObject;

  var xitems: any = [];
  const items = state.contextMenuManager.contextMenuItems;

  function getIconElm(item: any) {
    let iconElm: any = null;
    if (item.iconName) {
      iconElm = (
        <div style={{ color: item.iconColor ? item.iconColor : "" }}>
          <i className={`las la-${item.iconName}`}></i>
        </div>
      );
      // iconElm = <FontAwesomeIcon icon={item.icon} />;
    }

    if (item.image) {
      iconElm = item.image;
    } else if (item.icon) {
      iconElm = item.icon;
    }
    return iconElm;
  }

  if (items) {
    if (items.items) {
      if (items.title) {
        xitems.push(
          <div
            style={{
              width: "100%",
              textAlign: "left",
              borderBottom: "1px solid var(--text-color)",
            }}
            id="title"
          >
            {items.title}
          </div>,
        );
      }
      for (let i in items.items) {
        const item = items.items[i];
        var subLabelElm: any = null;
        if (item.subLabel) {
          subLabelElm = (
            <span style={{ paddingLeft: "5px", fontSize: "0.75rem" }}>
              {`(${state.translate("contxtMenu.copyFrom", "Kopie von")} ${item.subLabel})`}
            </span>
          );
        }

        const defaultIconStyle: any = {
          width: "1em",
          height: "100%",
          alignSelf: "stretch", // no itx
        };
        const disabled = state.contextMenuManager.disabledContextMenuItems.includes(item.id);
        if (item.menu) {
          const menuItems = new Array<any>();
          if (Array.isArray(item.menu?.items)) {
            item.menu.items.forEach((menuItem: any) => {
              menuItems.push(
                <Item
                  onClick={(p: any) => {
                    state.eventLogger.addEvent(EventKey.ContextMenuItemClicked, {
                      menuId: menuItem.id || item.id,
                      contextobj: state.contextMenuManager.currentObject
                        ? state.contextMenuManager.currentObject.id +
                          "_" +
                          state.contextMenuManager.currentObject.tag +
                          "_" +
                          state.contextMenuManager.currentObject.displayName
                        : undefined,
                    });
                    menuItem.onClick?.(p);
                  }}
                >
                  <div style={{ width: "30px", marginRight: "10px" }}>{getIconElm(menuItem)}</div> {menuItem.label}
                </Item>,
              );
            });
          }

          const submenuLabel = (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: "30px", marginRight: "10px", flexShrink: 0 }}>{getIconElm(item)}</div>
              {state.translate(item.label, item.label)}
            </div>
          );
          xitems.push(<Submenu label={submenuLabel}>{menuItems}</Submenu>);
        } else {
          xitems.push(
            <Item
              disabled={disabled}
              onClick={(p: any) => {
                state.eventLogger.addEvent(EventKey.ContextMenuItemClicked, {
                  menuId: item.label || item.id,
                  contextobj: state.contextMenuManager.currentObject
                    ? state.contextMenuManager.currentObject.id +
                      "_" +
                      state.contextMenuManager.currentObject.tag +
                      "_" +
                      state.contextMenuManager.currentObject.displayName
                    : undefined,
                });
                item.onClick?.(p);
              }}
            >
              <div id={item.id} style={{ width: "30px", marginRight: "10px" }}>
                {getIconElm(item)}
              </div>
              {state.translate(item.label, item.label)}
              {subLabelElm}
            </Item>,
          );
        }
      }
    } else {
      xitems = items;
    }
  } else {
    return null;
  }

  return <Menu id={MENU_ID}>{xitems}</Menu>;
}
